import {
  IsBoolean,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
} from 'class-validator';

export class TreasuryBankingCreateAccountRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsString()
  @MaxLength(50)
  accountName: string;

  @IsString()
  currency: string;

  @IsBoolean()
  @IsOptional()
  acceptFeesAndCharges?: boolean;

  @IsBoolean()
  @IsOptional()
  updateFireAccountInBusinessEntity?: boolean;

  @IsBoolean()
  @IsOptional()
  isWithdrawalAccount?: boolean;
}
